import { useCallback, useEffect, useState } from 'react';

export function usePressed() {
    const [isPointerDown, setIsPointerDown] = useState(false);
    const [isInside, setIsInside] = useState(false);
    const onPointerDown = useCallback(() => {
        setIsPointerDown(true);
    }, []);
    const onPointerEnter = useCallback(() => {
        setIsInside(true);
    }, []);
    const onPointerLeave = useCallback(() => {
        setIsInside(false);
    }, []);

    useEffect(() => {
        function docPointerUp() {
            setIsPointerDown(false);
        }

        document.addEventListener('pointerup', docPointerUp);

        return () => {
            document.removeEventListener('pointerup', docPointerUp);
        };
    }, []);

    return {
        pointerEvents: {
            onPointerDown,
            onPointerEnter,
            onPointerLeave,
        },
        isPressingInside: isInside && isPointerDown,
    };
}
